import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const variants = {
  primary:
    'bg-bspl-accent text-white border border-bspl-accent hover:bg-[#E63E00] hover:border-[#E63E00]',
  secondary:
    'bg-bspl-dark text-white border border-bspl-dark hover:bg-[#1a1a1a]',
  outline:
    'bg-transparent text-bspl-text border border-bspl-dark hover:bg-bspl-dark hover:text-white',
  ghost:
    'bg-transparent text-bspl-accent border border-transparent hover:text-[#E63E00]',
  'cta-white':
    'bg-white text-bspl-accent border border-white hover:bg-bspl-dark hover:text-white hover:border-bspl-dark',
  'cta-inverted':
    'bg-bspl-dark text-white border border-bspl-dark',
};

const sizes = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-3 text-base',
  lg: 'px-8 py-4 text-base',
};

const MotionLink = motion(Link);
const MotionButton = motion.button;
const MotionA = motion.a;

const Button = forwardRef(function Button(
  {
    children,
    variant = 'primary',
    size = 'md',
    className = '',
    to,
    href,
    external,
    type = 'button',
    ...props
  },
  ref
) {
  const base =
    'inline-flex items-center justify-center gap-2 font-semibold font-body rounded-btn transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bspl-accent focus-visible:ring-offset-2';
  const classes = `${base} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`;

  const motionProps = {
    whileHover: { scale: 1.03 },
    whileTap: { scale: 0.97 },
    transition: { duration: 0.15 },
    ...props,
  };

  if (to) {
    return (
      <MotionLink ref={ref} to={to} className={classes} {...motionProps}>
        {children}
      </MotionLink>
    );
  }

  if (href) {
    return (
      <MotionA
        ref={ref}
        href={href}
        className={classes}
        target={external ? '_blank' : undefined}
        rel={external ? 'noopener noreferrer' : undefined}
        {...motionProps}
      >
        {children}
      </MotionA>
    );
  }

  return (
    <MotionButton ref={ref} type={type} className={classes} {...motionProps}>
      {children}
    </MotionButton>
  );
});

export default Button;
